import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';

import { Flex, Modal, P } from '@decisiv/ui-components';
import History from '@decisiv/iconix/lib/components/History';

import WmiCodesApi from '../../api/wmi_codes';
import WrapperWithLoading from '../WrapperWithLoading';
import HistoryTable from '../ChangeHistory/HistoryTable';
import { flattenHistories } from '../ChangeHistory/utils';

export default function WmiCodeHistoryModal({
  visible,
  onClose,
  wmiCode = null,
}) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    if (!visible || !wmiCode) return;

    setLoading(true);
    setExpandedRows([]);
    WmiCodesApi.fetchWmiCodeChangeHistory(wmiCode.id).then((result) => {
      setHistory(result.data || []);
      setLoading(false);
    });
  }, [visible, wmiCode]);

  const handleToggleRow = (rowKey) => {
    setExpandedRows((prev) =>
      prev.includes(rowKey)
        ? prev.filter((k) => k !== rowKey)
        : [...prev, rowKey],
    );
  };

  const oemName = wmiCode?.attributes?.oem_name;
  const rows = flattenHistories(history);

  return (
    <Modal
      actions={[{ text: t`Close`, onClick: onClose, kind: 'secondary' }]}
      intent="information"
      icon={History}
      title={oemName ? t`Audit History — ${oemName}` : t`Audit History`}
      visible={visible}
      onClose={onClose}
    >
      <Flex flexDirection="column" style={{ minHeight: '200px' }} padding={1}>
        <WrapperWithLoading loading={loading}>
          {rows.length === 0 ? (
            <P shade={1}>{t`No history available.`}</P>
          ) : (
            <HistoryTable
              rows={rows}
              expandedRows={expandedRows}
              onToggleRow={handleToggleRow}
            />
          )}
        </WrapperWithLoading>
      </Flex>
    </Modal>
  );
}

WmiCodeHistoryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  wmiCode: PropTypes.shape({
    id: PropTypes.string,
    attributes: PropTypes.shape({
      oem_name: PropTypes.string,
    }),
  }),
};
